import request from '@/utils/request'
// 奖金列表
export function bonusList(data) {
  return request({
    url: '/sys/bonus/list',
    method: 'post',
    data
  })
}
// 奖金删除
export function bonusDelete(data) {
  return request({
    url: '/sys/bonus/delete',
    method: 'post',
    data
  })
}

// 奖金新增
export function bonusAdd(data) {
  return request({
    url: '/sys/bonus/save',
    method: 'post',
    data
  })
}

// 奖金修改
export function bonusUpdate(data) {
  return request({
    url: '/sys/bonus/update',
    method: 'post',
    data
  })
}
